<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">사용자 매뉴얼</span>
            <span class="txt">센터 admin에 보여질 사용자 매뉴얼 게시글을 작성 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!manualList"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link v-if="careAuth === true" class="com-btn blue" to="/madmin/manual/edit">
                        글쓰기
                    </router-link>
                </div>
            </div>
            <table class="com-table">
                <colgroup>
                    <col style="width: 120px" />
                    <col style="width: 1000px" />
                    <col style="width: 205px" />
                    <col style="width: 205px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>등록일</th>
                        <th>제목</th>
                        <th>글쓴이</th>
                        <th>조회수</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(manual, index) in manualList" :key="index">
                        <td>{{ manual.b_cre_dt | timestampFilter }}</td>
                        <td>
                            <router-link :to="`/madmin/manual/detail/${manual.b_manual_qa_id}`" class="ic-link">
                                <span class="ic">{{ manual.b_cate_nm }}</span>
                                <span
                                    :class="{
                                        txt: true,
                                        red: manual.b_top_fix_yn === true,
                                        new: newPost(manual.b_cre_dt),
                                    }"
                                >
                                    {{ manual.b_title }}
                                </span>
                            </router-link>
                        </td>
                        <td>{{ manual.b_cre_nm === 'root@root.com' ? '핏투데이케어' : manual.b_cre_nm }}</td>
                        <td>{{ manual.b_view_cnt }}</td>
                    </tr>
                    <tr v-if="manualList.length === 0">
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link v-if="careAuth === true" class="com-btn blue" to="/madmin/manual/edit">
                        글쓰기
                    </router-link>
                </div>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { calcNewPost } from '@/assets/js/validation.js';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'manualList',
    props: {},
    computed: {
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            // 케어 권한 확인
            this.careAuth = true;
        }
        this.fetchManualList();
    },
    data() {
        return {
            careAuth: false,
            manualList: null,
            pagingInfo: { ...pagingInfo },
        };
    },
    methods: {
        // 최근 게시글(N) 표시 위한 날짜 계산, true면 새 게시글
        newPost(creDt) {
            return calcNewPost(creDt);
        },

        // 사용자 매뉴얼 목록 Fetch
        async fetchManualList() {
            try {
                const { data } = await this.getManualList();
                console.log('===> Success Load ManualList : ', data);
                this.setPageParams(data);
                this.manualList = data.items;
            } catch (error) {
                console.log(error);
            }
        },

        // 사용자 매뉴얼 목록 조회 API 호출
        getManualList() {
            return api.get('/admin/api/board/manual-qa', {
                params: {
                    ...this.pagingInfo,
                },
            });
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.fetchManualList();
        },

        // 페이징 Param set
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
    },
};
</script>
<style lang="scss"></style>
